export default __webpack_public_path__ + "static/media/cityBackground.efe8eda6.png";